// src/pages/BookAppointment.jsx
import SectionTitle from '../components/common/SectionTitle';
import Button from '../components/common/Button';

const BookAppointment = () => {
  return (
    <main className="pb-24">
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Book Your Appointment Today
          </h1>
          <p className="text-xl max-w-2xl mx-auto">
            Take the first step toward a healthier, more confident smile.
          </p>
        </div>
      </section>

      <section className="py-16 -mt-12">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
            <SectionTitle title="Appointment Details" />
            <form className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <input type="text" placeholder="Full Name *" required className="w-full p-4 border rounded-lg" />
                <input type="tel" placeholder="Phone Number *" required className="w-full p-4 border rounded-lg" />
              </div>
              <input type="email" placeholder="Email Address" className="w-full p-4 border rounded-lg" />
              <select className="w-full p-4 border rounded-lg">
                <option>Select Treatment</option>
                <option>Dental Implants</option>
                <option>Root Canal</option>
                <option>Teeth Whitening</option>
                <option>Braces / Aligners</option>
                <option>Pediatric Dentistry</option>
                <option>Other</option>
              </select>
              <input type="date" className="w-full p-4 border rounded-lg" />
              <textarea placeholder="Additional Notes / Concerns" rows={4} className="w-full p-4 border rounded-lg" />
              <Button type="submit" className="w-full py-4 text-lg">
                Confirm Appointment
              </Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BookAppointment;